import { Platform } from '@/utils/platform';
import { handle } from '../../QTBridge';
import { POPOBridgeEmitter } from '@popo-bridge/web';
import { bridgeEventEmitter } from '../../eventEmitter';
import { callbackToNative } from '../../callhandle/callbackToNative';

export interface GenerateSnapshotResult {
  snapshotId: number;
}
export type GenerateSnapshotHandler = (evt: GenerateSnapshotResult) => void;

export const onGenerateSnapshot = async (cb: GenerateSnapshotHandler) => {
  if (Platform.isPC) {
    return bridgeEventEmitter.addListener('generateSnapshot', async (data, sessionId) => {
      cb(data as GenerateSnapshotResult);
      callbackToNative({
        status: 1,
        data: {},
        message: '',
        sessionId: sessionId as string
      })
    });
  } else {
    return POPOBridgeEmitter.addListener('generateSnapshot', async (data) => {
      cb(data as GenerateSnapshotResult);
    });
  }
};
